// import { 
//   DashboardOutlined
// } from '@ant-design/icons';
import { APP_PREFIX_PATH } from 'configs/AppConfig'

const dashBoardNavTree = [{
  key: 'menu',
  path: `${APP_PREFIX_PATH}/menu`,
  title: 'Menu',
  breadcrumb: false,
  submenu: []
},{
  key: 'search',
  path: `${APP_PREFIX_PATH}/search`,
  title: 'Search',
  breadcrumb: false,
  submenu: []
},{
  key: 'branches',
  path: `${APP_PREFIX_PATH}/branches`,
  title: 'Branches',
  breadcrumb: false,
  submenu: []
},{
  key: 'OrderStatus',
  path: `${APP_PREFIX_PATH}/order-status`,
  title: 'Order Status',
  breadcrumb: false,
  submenu: []
}]

const navigationConfig = [
  ...dashBoardNavTree
]

export default navigationConfig;
